import { Link } from 'react-router-dom';

// Şifre sıfırlama / e-posta onayı sayfaları için ortak kabuk (AkıllıÇözüm koyu, WeddingTakip açık)
export const AuthShell = ({ variant, title, subtitle, loginPath, children, testId }) => {
  const dark = variant === 'hesap';
  return (
    <div className={`min-h-screen flex items-center justify-center px-4 ${dark ? 'bg-slate-950' : 'bg-background'}`} data-testid={testId}>
      {dark && <div className="absolute -top-40 -left-40 w-96 h-96 bg-emerald-500/25 rounded-full blur-3xl pointer-events-none" />}
      <div className={`relative w-full max-w-md rounded-2xl p-7 sm:p-8 shadow-2xl ${dark ? 'backdrop-blur-xl bg-white/[0.03] border border-white/10' : 'bg-card border border-border'}`}>
        <h1 className={`text-xl font-bold ${dark ? 'text-white' : ''}`}>{title}</h1>
        {subtitle && <p className={`text-sm mt-1 mb-6 ${dark ? 'text-slate-400' : 'text-muted-foreground'}`}>{subtitle}</p>}
        {children}
        <div className={`mt-6 pt-5 border-t text-center text-sm ${dark ? 'border-white/10' : 'border-border'}`}>
          <Link to={loginPath} className={dark ? 'text-emerald-400 hover:text-emerald-300 font-medium' : 'text-primary hover:underline font-medium'} data-testid="auth-back-to-login">
            ← Giriş sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export const authInputClass = (variant) => (variant === 'hesap'
  ? 'h-11 bg-white/5 border-white/10 text-white placeholder:text-slate-600 focus-visible:ring-emerald-500'
  : 'h-11');

export const authButtonClass = (variant) => (variant === 'hesap'
  ? 'w-full h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold'
  : 'w-full h-11');
